export default "__VITE_ASSET__1ac1a7a9__"